<div [classList]="class"
>
    <ng-content></ng-content>
</div>
